import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({})

function registerStoreModule (module, name) {
  if (!name || store.hasModule(name)) return
  const _module = Object.assign({}, module)
  store.registerModule(name, _module)
}

const storeContexts = require.context('./modules', true, /index\.js$/)
storeContexts.keys().forEach(name => {
  const moduleName = name.match(/.*?\//g)[1].split('/')[0]
  registerStoreModule(storeContexts(name).default, moduleName)
})

export default store
